module.exports = __webpack_public_path__ + "media/images/icons/country_flags/py-071e1fd0fcd266b47192b602e1fa5e0d.svg";